<template lang="pug">
div.d-flex.align-center
  div.c1.basic600--text {{ text }}
  div.ml-2.mr-3(style="width: 65px")
    v-select.c1.page-size(v-model="pageSize" outlined dense :items="pageSizes" hide-selected hide-details)
      template(v-slot:append)
        eva-icon(name="chevron-down-outline" width="20" height="20" style="margin-top: 2px" :fill="$vuetify.theme.themes[$theme].basic700")
  v-spacer
  div
    v-btn.rounded-l(:class="{ primary500: page !== 1, primary300: page === 1 }" tile icon height="32" width="32" @click="page--" :disabled="page === 1")
      eva-icon(style="padding-top: 4px; padding-right: 2px;" name="arrow-ios-back-outline" height="17" :fill="$vuetify.theme.themes[$theme].basic100")
  div.pl-3
    div(style="width: 65px")
      v-select.c1.page-current(v-model="page" outlined dense :items="pages" hide-details append-icon="")
        template(v-slot:selection="{ item }")
          div.d-flex.justify-center(style="width: 100%;")
            div.text-center {{ item }} / {{ totalPages }}
  div.pl-3
    v-btn.rounded-r(:class="{ primary500: page !== totalPages, primary300: page === totalPages }" tile icon height="32" width="32" @click="page++" :disabled="page === totalPages")
      eva-icon(style="padding-top: 4px; padding-right: 2px;" name="arrow-ios-forward-outline" height="17" :fill="$vuetify.theme.themes[$theme].basic100")
</template>

<script>
export default {
  name: 'YPaginationCustom',
  props: ['value', 'parentPageSize', 'count', 'text'],
  data: (vm) => ({
    page: vm.value || 36,
    pageSizes: [20, 40, 80, 100, 500]
  }),
  computed: {
    totalPages () {
      return Math.ceil(this.count/this.pageSize)
    },
    pageSize: {
      get() {
        return this.parentPageSize
      },
      set(newValue) {
        this.$emit('update:parentPageSize', newValue)
      }
    },
    pages () {
      let data = []
      for (let i = 1; i <= this.totalPages; i++) {
        data.push(i)
      }
      return data
    }
  },
  watch: {
    value (val) {
      this.page = val
    },
    page (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
  margin-top: 4px;
  height: 38px;
}
::v-deep .page-size > .v-input__control > .v-input__slot {
  padding: 0 2px 0 8px !important;
}
::v-deep .page-current > .v-input__control > .v-input__slot {
  padding: 0 8px 0 8px !important;
}
</style>